window.addEventListener("DOMContentLoaded", () => {
  console.log("INIT");

  /*
  let inputAltezza = document.getElementById("altezza")
  
  if (document.getElementById("altezza")){
      const parent = document.querySelector('.buy-buttons');
      const btn = parent.querySelector('button');
      btn.disabled = true;
      inputAltezza.addEventListener("input", (e) => {
          if (inputAltezza.value.length === 0) {
              btn.disabled = true;
            } else {
              btn.disabled = false;
            }
        });
  }
  */
  
});
